export enum ServerStateKeys {
  OrderComments = "orderComments",
  MessageConversation = "messageConversation",
  MessageInbox = "messageInbox",
  MessageUnread = "messageUnread",
  RelationshipComments = "relationshipComments",
  Relationships = "relationships",
  Orders = "orders",
  OrderDeliveryHistory = "orderDeliveryHistory",
  OrderDeliveryEvidence = "orderDeliveryEvidence",
  OpenOrders = "open-orders",
  OrdersLegacy = "ordersLegacy",
  OrderItems = "orderItems",
  OrderItemsExport = "orderItemsExport",
  OrderInvoiceUrl = "orderInvoiceUrl",
  OrderTracking = "orderTracking",
  SellarUser = "sellarUser",
  Integrations = "integrations",
  SellarIntegration = "sellarIntegration",
  SuppliersLegacy = "suppliersLegacy",
  Suppliers = "suppliers",
  SuppliersPaymentInformation = "suppliersPaymentInformation",
  SupplierStorefrontV1 = "supplierStorefrontV1",
  SupplierStorefrontV2 = "supplierStorefrontV2",
  SupplierFeed = "supplierFeed",
  SupplierDistance = "supplierDistance",
  SupplierRecentlyAdded = "supplierRecentlyAdded",
  SupplierRelationships = "supplierRelationships",
  SupplierRelationshipsAnaltyics = "supplierRelationshipsAnaltyics",
  SupplierRelationshipsExport = "supplierRelationshipsExport",
  SupplierRelationshipActivities = "supplierRelationshipActivities",
  SupplierRelationshipDiscounts = "supplierRelationshipDiscounts",
  SupplierRelationshipProductItemDiscounts = "supplierRelationshipProductItemDiscounts",
  SupplierRelationshipPaymentTermsRequest = "supplierRelationshipPaymentTermsRequest",
  PriceTiers = "priceTiers",
  PriceTierStats = "priceTierStats",
  PriceTierDiscounts = "priceTierDiscounts",
  PriceTierVolumeDiscounts = "priceTierVolumeDiscounts",
  PriceTierOrderRules = "priceTierOrderRules",
  ProductPriceTiersLegacy = "productPriceTiersLegacy",
  ProductPriceTiers = "productPriceTiers",
  Products = "products",
  CuratedProducts = "curatedProducts",
  StorefrontTags = "storefrontTags",
  NewReleases = "newReleases",
  ContainerTypes = "containerTypes",
  ProductProperties = "productProperties",
  Businesses = "businesses",
  BusinessUser = "businessUser",
  Retailers = "retailers",
  Tags = "tags",
  DeliveryChargeRules = "deliveryChargeRules",
  UserNotificationPreferences = "userNotificationPreferences",
  PaymentMethods = "paymentMethods",
  OrderIntegrationValue = "orderIntegrationValue",
  SupplierIntegrationValue = "supplierIntegrationValue",
  SupplierAnnouncement = "supplierAnnouncement",
  SupplierRelationshipIntegrationValues = "supplierRelationshipIntegrationValues",
  UserInvite = "userInvite",
  Ups = "ups",
  Collections = "collections",
  DeliveryArea = "deliveryArea",
  DeliveryAreaSellarDistribution = "deliveryAreaSellarDistribution",
  DiscoveryProducts = "discoveryProducts",
  DiscoverySuppliersWithProducts = "discoverySuppliersWithProducts",
  DiscoverySuggestions = "discoverySuggestions",
  DiscoverySuppliers = "discoverySuppliers",
  DiscoveryDistributionSuppliers = "discoveryDistributionSuppliers",
  DiscoveryProductRecentlyAdded = "discoveryProductRecentlyAdded",
  DiscoveryProductRecentlyAddedGroup = "discoveryProductRecentlyAddedGroup",
  DiscoveryProductBestSellers = "discoveryProductBestSellers",
  DiscoveryDistributionProductContainerTypes = "discoveryDistributionProductContainerTypes",
  DiscoveryDistributionProducts = "discoveryDistributionProducts",
  DiscoveryPreOrders = "discoveryPreOrders",
  XeroContacts = "xeroContacts",
  FulfillmentTypeContainerDeliveryCharge = "fulfillmentTypeContainerDeliveryCharge",
  FulfillmentType = "fulfillmentType",
  FulfillmentTypeV2 = "fulfillmentTypeV2",
  FulfillmentTypeStats = "fulfillmentTypeStats",
  CourierDeliverySchedule = "courierDeliverySchedule",
  StorefrontLink = "storefrontLink",
  StorefrontAvailability = "storefrontAvailability",
  StorefrontAvailabilityNotification = "storefrontAvailabilityNotification",
  Auth = "auth",
  Payments = "payments",
  PaymentIntents = "paymentIntents",
  QuickbooksCustomers = "quickbooksCustomers",
  Refunds = "refunds",
  RyftManagementAccount = "ryftManagementAccount",
  RyftManagementLedgerBalance = "ryftManagementLedgerBalance",
  RyftManagementPendingPayouts = "ryftManagementPendingPayouts",
  RyftManagementLedgerTransactions = "ryftManagementLedgerTransactions",
  RyftManagementPaymentSessionOrder = "ryftManagementPaymentSessionOrder",
  OrderEvents = "orderEvents",
  CaseSizeRules = "caseSizeRules",
  Acquisitions = "acquisitions",
  RetailerAcquisition = "retailerAcquisition",
  NotificationToken = "notificationToken",
  Analytics = "analytics",
  StockOverview = "stockOverview",
  InvoiceLineItem = "invoiceLineItem",
  Invoice = "invoice",
  OpeningOrderFee = "openingOrderFee",
  CreditNote = "creditNote",
  SupplierOutOfOffice = "supplierOutOfOffice",
  BuyerRelationship = "buyerRelationship",
  BuyerRelationshipCount = "buyerRelationshipCount",
  SpotlightPage = "spotlightPage",
  CreditProcessor = "creditProcessor",
  CreditProcessorPaymentAllocationEvents = "creditProcessorPaymentAllocationEvents",
  LegalEntity = "legalEntity",
  OrderDocument = "orderDocument",
  Payouts = "payouts",
  PayoutsStats = "payoutsStats",
  PayoutsNext = "payoutsNext",
  PayoutsFromInvoiceId = "payoutsFromInvoiceId",
  SellarImportsPayouts = "sellar-imports-payouts",
  SellarImportsPayoutsRevenueInvoice = "sellar-imports-payouts-revenue-invoice",
  Checkout = "checkout",
  CheckoutPaymentOptionsSupplier = "checkoutPaymentOptionsSupplier",
  SCOrders = "scOrders",
  Statements = "statements",
  SCCompanyStatement = "scCompanyStatement",
  ProductTemplate = "productTemplate",
  AvailabilityTiers = "AvailabilityTiers",
  ProductAvailabilityTiers = "productAvailabilityTiers",
  UngroupedProducts = "productUngrouped",
  PriceTierContainerDiscount = "priceTierContainerDiscount",
  CustomerZones = "customerZones",
  CustomerZonesDefault = "customerZonesDefault",
  CustomerZonePostcodes = "customerZonePostcodes",
  CustomerZoneDeliveryAreas = "customerZoneDeliveryAreas",
  DeliveryZoneModeAssignments = "deliveryZoneModeAssignments",
  VolumeDiscounts = "volumeDiscounts",
  VolumeDiscountsModeAssignments = "volumeDiscountsModeAssignments",
  OrderRules = "orderRules",
  OrderRulesStats = "orderRulesStats",
  Promotions = "promotions",
  PromotionRewardItems = "promotionRewardItems",
  Notifications = "notifications",
  Announcements = "announcements",
  FavouriteNotificationPreferences = "favouriteNotificationPreferences",
  ProductAssignment = "productAssignment",
  SCManagementPaymentMethods = "scManagementPaymentMethods",
  DirectDebitRequests = "directDebitRequests",
  StorefrontPreviewCustomerZones = "storefrontPreviewCustomerZones",
  StorefrontPreviewProducts = "storefrontPreviewProducts",
  StorefrontPreviewOrderRules = "storefrontPreviewOrderRules",
  StorefrontPreviewCustomers = "storefrontPreviewCustomers",
  PriceListBaseList = "priceListBaseList",
  DistributionTasks = "distributionTasks",
  DistributionRoutes = "distributionRoutes",
  DistributionRouteStops = "distributionRouteStops",
  DistributionVehicles = "distributionVehicles",
  OrderApcTracking = "orderApcTracking",
  SellarDistributionCollection = "sellarDistributionCollection",
  SellarDistributionCollectionList = "sellarDistributionCollectionList",
  SellarDistributionPalletShipment = "SellarDistributionPalletShipment",
  DistributionNonWorkingDays = "distributionNonWorkingDays",
  SellarDistributionContact = "sellarDistributionContact",
  SellarDistributionAvailability = "sellarDistributionAvailability",
  SellarDistributionAvailabilityDistributionDeliveryEstimateTimetableList = "sellarDistributionAvailabilityDistributionDeliveryEstimateTimetableList",
  SellarDistributionAvailabilityUpcomingDelivery = "sellarDistributionAvailabilityUpcomingDelivery",
  SellarDistributionAvailabilityDriverList = "sellarDistributionAvailabilityDriverList",
  TwoMerchantCustomerPaymentMethod = "twoMerchantCustomerPaymentMethod",
  TwoCompanySearch = "twoCompanySearch",
  TwoCreditLimitQuote = "twoCreditLimitQuote",
  LegalEntityCreditLimitInfo = "legalEntityCreditLimitInfo",
  TwoPreverificationAccount = "twoPreverificationAccount",
  twoBillingPeriodSummary = "twoBillingPeriodSummary",
  twoDownloadStatementUrl = "twoDownloadStatementUrl",
  XeroChartOfAccounts = "xeroChartOfAccounts",
  TwoCreateBusinessRegistrationApplication = "twoCreateBusinessRegistrationApplication",
  TwoCreditOrderPaymentLink = "twoCreditOrderPaymentLink",
  OpenDistributionOrders = "openDistributionOrders",
  DeliveryMethodContainerRules = "deliveryMethodContainerRules",
  DeliveryMethodContainerRulesContainerTypes = "deliveryMethodContainerRulesContainerTypes",
  DeliveryMethodContainerRulesForSD = "deliveryMethodContainerRulesForSD",
  PaymentLink = "paymentLink",
  OrderLinkFlowOrder = "orderLinkFlowOrder",
  OrderLinkFlowHasAccount = "orderLinkFlowHasAccount",
  UnifiedCheckoutBaskets = "unifiedCheckoutBaskets",
}
